export const ServiceData = [
  {
    id: 1,
    serviceName: "Thomas",
    description: "201",

  },
  {
    id: 2,
    serviceName: "Rose",
    description: "201sdfsdfsd",
  },

];
